// extracted by mini-css-extract-plugin
export var gif = "_kd-0";